export enum SortOrder {
  NONE = 0,
  ASC = 1,
  DESC = -1,
}

export class PaginationListRequest {
  PageNumber: number | null;
  PageSize: number | null;
  SortColumn: string | null;
  SortOrder: SortOrder | string | null;
}

export enum ClientType {
  Particular = 1,
  Company = 2,
 ForeignCompany = 3
}

export interface BaseApiResponse<IError> {
  IsSuccess: boolean;
  Errors: IError[];
}
